import styled from 'styled-components';
/* eslint-disable no-magic-numbers -- surface tokens are named by number */
import { mainTheme } from '../themes/mainTheme';
/* eslint-disable max-len */

type Variant = 'info' | 'warning' | 'danger' | 'success' | 'neutral';

// The same soft pairs Label uses: a dark fill with its matching light text.
export const variantColors: Record<Variant, { bg: string; text: string }> = {
	info: { bg: mainTheme.surface[4], text: mainTheme.text.primary },
	warning: { bg: mainTheme.fill.warning, text: mainTheme.text.warning },
	danger: { bg: mainTheme.fill.danger, text: mainTheme.text.danger },
	success: { bg: mainTheme.fill.success, text: mainTheme.text.success },
	neutral: { bg: mainTheme.fill.dimmed, text: mainTheme.text.secondary },
};

const getVariantColor = ($variant: Variant) => (variantColors[$variant] ?? variantColors.neutral).text;

export const IconWrapper = styled.div<{ $variant: 'info' | 'warning' | 'danger' | 'success' | 'neutral' }>`
	color: ${({ $variant }) => getVariantColor($variant)};
	.icon {
		font-size: 24px;
		margin-top: -4px;
	}

	svg {
		fill: currentColor;
	}
`;

export const CloseButton = styled.button<{ $variant: 'info' | 'warning' | 'danger' | 'success' | 'neutral' }>`
	background: none;
	border: none;
	cursor: pointer;
	padding: 4px;
	display: flex;
	align-items: center;
	justify-content: center;
	position: absolute;
	right: 12px;
	top: 10px;
	color: ${({ $variant }) => getVariantColor($variant)};

	.icon {
		font-size: 24px;
	}

	svg {
		fill: currentColor;
	}
`;

export const SimpleInfoBoxWrapper = styled.div<{ 
	$variant: string; 
	$isExiting: boolean;
	$height: string;
}>`
	
	background-color: ${({ $variant }) => (variantColors[$variant as Variant] ?? variantColors.neutral).bg};
	border-radius: 2px;
	width: 100%;
	align-items: center;
	height: ${({ $height }) => $height};
	overflow: hidden;
	transition: all 300ms ease-in-out;
`; 

export const SimpleInfoBoxContainer = styled.span`
	padding: 16px;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	width: 100%;
`;

export const SimpleInfoBoxContentWrap = styled.span`
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	gap: 12px;
`;

export const SimpleInfoBoxContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
`;

export const SimpleInfoBoxHeadline = styled.span<{ $variant: 'info' | 'warning' | 'danger' | 'success' | 'neutral' }>`
	font-size: 16px;
	font-weight: 600;
	font-family: "Red Hat Display", sans-serif;
	margin: 0;
	color: ${({ $variant }) => getVariantColor($variant)};
`;

export const SimpleInfoBoxText = styled.span<{ $variant: 'info' | 'warning' | 'danger' | 'success' | 'neutral' }>`  
	font-size: 14px;
	margin: 0;
	font-weight: 400;
	font-family: "Red Hat Display", sans-serif;
	color: ${({ $variant }) => getVariantColor($variant)};
`;

export const SimpleInfoBoxContent = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 8px;
`;

export const SimpleInfoBoxLink = styled.a`
	font-size: 14px;
	margin: 0;
	font-weight: 400;
	font-family: "Red Hat Display", sans-serif;
	color: ${mainTheme.text.brand};
	
	&:hover {
		.icon {
			transform: translateX(4px);
		}
	}

	.icon {
		font-size: 20px;
		margin-left: 2px;
		transition: transform 0.2s ease-in-out;
	}
`;
